
import { Avatar_02, Avatar_16 } from "Routes/ImagePath";


const Image = (props) => {
    // Add lazy loading by default unless explicitly disabled
    const { loading = "lazy", ...restProps } = props;
    return (
        <img  
            {...restProps}  
            loading={loading}
            src={props.src || require(`assets/img/${props?.type=="user"? "user.jpg" : "placeholder.webp"}`) }
        />
    )
}
export default Image